import * as React from 'react';
import { Label } from '../label';
import { FormControl, FormItem, FormMessage } from '../form';
import { SelectLabel, SelectProps } from '@radix-ui/react-select';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select';

export interface SelectGroupOptionProps {
  name: string;
  value: string;
}

export interface SelectGroupContentProps {
  label: string;
  options: SelectGroupOptionProps[];
}

interface SelectGsProps extends SelectProps {
  label?: string;
  placeholder?: string;
  content: SelectGroupContentProps[];
  isLoading?: boolean;
}

const SelectGroupGs = React.forwardRef<HTMLBaseElement, SelectGsProps>(
  (
    { label, placeholder, onValueChange, value, content, isLoading = false },
    ref
  ) => {
    return (
      <FormItem {...ref}>
        <div className="grid w-full items-center gap-1.5">
          {label && (
            <Label className="font-GilroySemibold text-sm text-slate-800">
              {label}
            </Label>
          )}
          <Select
            onValueChange={onValueChange}
            value={value}
            disabled={isLoading}
          >
            <FormControl>
              <SelectTrigger className="border-solid focus:ring-primary-500 text-slate-500 font-sans">
                <SelectValue placeholder={placeholder || 'Selecione'} />
              </SelectTrigger>
            </FormControl>
            <SelectContent className="max-h-96 overflow-auto font-sans">
              {content.map((group, key) => (
                <SelectGroup key={key}>
                  <SelectLabel className="font-semibold text-base pl-8 bg-gray-100 py-3 rounded-sm mb-1">
                    {group.label}
                  </SelectLabel>
                  {group.options.map((item) => (
                    <SelectItem key={item.value} value={item.value.toString()}>
                      {item.name}
                    </SelectItem>
                  ))}
                </SelectGroup>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </div>
      </FormItem>
    );
  }
);

SelectGroupGs.displayName = 'SelectGroupGs';

export { SelectGroupGs };
